module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "show-close": _vm.canClose,
      "width": "550px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": true
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', {
    staticClass: "rental-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.skiletting.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', [(_vm.paramsType === 'without-delivery') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.people-count-title')))]) : _vm._e(), _vm._v(" "), (_vm.guidedRentals.length) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skipass.existing-booking-title')))], 1), _vm._v(" "), _c('p', [_vm._v("Du har en påbörjad bokning i varukorgen. Du kommer att radera den bokningen om du fortsätter. Klicka på "), _c('i', [_vm._v("\"Fortsätt tidigare bokning\"")]), _vm._v(" för att ändra den påbörjade bokningen istället.")])]) : _vm._e(), _vm._v(" "), (_vm.guidedRentals.length) ? _c('div', {
    staticClass: "blocked center"
  }, [(_vm.guidedRentals.length) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.goOn()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skipass.existing-booking-continue')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.paramsType === 'with-delivery' && _vm.accomodation) ? _c('h1', {
    staticClass: "accomodation-title"
  }, [_vm._v(_vm._s(_vm.accomodation.name))]) : _vm._e()]), _vm._v(" "), (_vm.paramsType === 'with-delivery') ? _c('div', [(!_vm.loggedIn && !_vm.accomodation) ? _c('div', [_c('div', {
    staticClass: "blocked info",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.find-accomodation')))], 1), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.$t('skirental.free-delivery-text', {
    clickhere: ''
  })) + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'accomodation list'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.clickhere')))]), _vm._v(".\n        ")], 1)]), _vm._v(" "), _c('Login', {
    on: {
      "login": _vm.onLogin
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn || _vm.accomodations.length) ? _c('div', [(_vm.accomodation) ? _c('AccomodationPeriodConfirm', {
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure,
      "small": true,
      "check-availability": false
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (!_vm.accomodations.length && !_vm.loading) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.no-accomodation-title')))], 1), _vm._v(" "), (!_vm.foundNotAllowedDelivery) ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.no-accomodation-text')))]) : _vm._e(), _vm._v(" "), (_vm.foundNotAllowedDelivery) ? _c('p', [_vm._v("Vi hittade inga boenden där utkörning är möjligt.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.accomodations.length > 1) ? _c('div', {
    staticClass: "blocked"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('skirental.pick-accomodation')))]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.accomodationsToSelect,
      "valuebinder": _vm.selectedAccomodation,
      "validated": _vm.accomodation,
      "label": !_vm.accomodation ? _vm.$t('skirental.pick-accomodation') : _vm.accomodation.name,
      "allow-empty": false
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.selectedAccomodation = $event
      },
      "changed": _vm.changedAccomodation
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.accomodations.length) ? _c('p', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.possibleWithStorage) ? _c('div', {
    staticClass: "blocked info test"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v("Obs! Nattförvaring")], 1), _vm._v(" "), _c('p', [_vm._v("Istället för utkörning har ditt boende ett förvaringsbås i skiduthyrningen fem meter från åkbar snö. I ditt skidnära bås kan du förvara dina skor under dagen så att du kan gå i dina bekväma skor till och från ditt boende.")]), _vm._v(" "), (_vm.accomodations.length > 1) ? _c('p', [_vm._v(" ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.possibleWithDelivery) ? _c('div', {
    staticClass: "blocked info extra-info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.delivery.close-time-title')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skirental.delivery.close-time-text-1')))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openWithoutDelivery($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.clickhere')))]), _vm._v(" " + _vm._s(_vm.$t('skirental.delivery.close-time-text-2', {
    clickhere: ''
  })))])]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), (_vm.paramsType === 'without-delivery' || (_vm.accomodation && _vm.possibleWithDelivery)) ? _c('div', {
    staticClass: "blocked center"
  }, [_c('b', {
    staticClass: "uppercase block"
  }, [_vm._v(_vm._s(_vm.$t('general.people-count')))]), _vm._v(" "), _c('CounterButton', {
    ref: "counterButton",
    staticClass: "counter-button",
    attrs: {
      "inline": true,
      "count": _vm.peopleCount,
      "min": 1,
      "suffix": ' ' + _vm.$t('general.pieces-short')
    },
    on: {
      "changedCount": function($event) {
        return _vm.changePeople($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'without-delivery' || (_vm.accomodation && _vm.possibleWithDelivery)) ? _c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.startBooking()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.cta.begin-booking')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'with-delivery' && _vm.SITE_CONFIG.rental.delivery_fee_active && _vm.SITE_CONFIG.rental.delivery_fee_price > 0 && !_vm.$store.state.cart.parent_has_delivery_fee && !(_vm.accomodation && _vm.accomodation.parent_has_delivery_fee)) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s('Utkörningsavgift'))], 1), _vm._v(" "), _c('p', [_vm._v("Utkörning kostar " + _vm._s(_vm.SITE_CONFIG.rental.delivery_fee_price) + " kr per bokning.")])]) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'with-delivery') ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.delivery.time-title')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skirental.delivery.time-text')))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.accomodation && !_vm.$store.state.isOnSite) ? _c('div', {
    staticClass: "blocked info"
  }, [(_vm.paramsType === 'without-delivery') ? _c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.delivery.delivery')))], 1) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'with-delivery') ? _c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.delivery.pickup')))], 1) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'without-delivery') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.delivery.delivery-text')) + "\n      "), (!_vm.addonBooking) ? _c('span', [_vm._v("\n        Gör en tilläggsbokning från "), _c('a', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openWithDelivery($event)
      }
    }
  }, [_vm._v("Mina sidor")]), _vm._v(" istället.\n      ")]) : _c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openWithDelivery($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.delivery.click-here')))])])]) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'with-delivery') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.delivery.pickup-text')) + " "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openWithoutDelivery($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.delivery.click-here')))])]) : _vm._e()]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b6b825a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiRentalPickDate.vue
// module id = 963
// module chunks = 0